import { render, staticRenderFns } from "./SVG.vue?vue&type=template&id=f8a3992a"
import script from "./SVG.vue?vue&type=script&lang=js"
export * from "./SVG.vue?vue&type=script&lang=js"
import style0 from "./SVG.vue?vue&type=style&index=0&id=f8a3992a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports